import Vue from 'vue';
import VueRouter from 'vue-router';
import smart from '../views/intelligentAssistant/intelligentAssistant.vue';

Vue.use(VueRouter);

const routes = [{
        path: '/',
        name: 'smart',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/intelligentAssistant/intelligentAssistant.vue'),
    },
    {
      path: '/history',
      name: 'History',
      component: () =>
          import ( /* webpackChunkName: "about" */ '../views/historyQuestion/historyQuestion.vue'),
    },
    {
      path: '/questionDetail',
      name: 'QuestionDetail',
      component: () =>
          import ( /* webpackChunkName: "about" */ '../views/questionDetail/questionDetail.vue'),
    },
    {
      path: '/feedBack',
      name: 'feedBack',
      component: () =>
          import ( /* webpackChunkName: "about" */ '../views/feedBack/feedBack.vue'),
    },
    {
      path: '/successSub',
      name: 'successSub',
      component: () =>
          import ( /* webpackChunkName: "about" */ '../views/successSub/successSub.vue'),
    },



];

const router = new VueRouter({
    mode: 'history',
    base: 'jiqiren',
    routes,
});

router.beforeEach((to, from, next) => {
    console.groupEnd();
    if (to.meta.needLoginIn) {

    } else {
        next();
    }
});
export default router;
